<template>
  <div class="page-advertisement">
    <BaseTitle
      v-if="placement === AdDisplayAt.BrochureEndRight"
      class="grid-title centered"
      >{{ $t("brochure.also-interesting") }}</BaseTitle
    >

    <div class="similar-brochures">
      <SimilarBrochuresForBrochureGrid
        v-if="placement === AdDisplayAt.BrochureEndRight"
        :input="{ brochureId }"
      >
        <Advertisement :display-at="placement" />
      </SimilarBrochuresForBrochureGrid>
      <Advertisement v-else :display-at="placement" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouteParams } from "@vueuse/router";
import { AdDisplayAt } from "~/graphql/generated";

defineProps<{
  placement: AdDisplayAt;
}>();

const brochureId = useRouteParams<string>("id");
</script>

<style lang="scss" scoped>
.page-advertisement {
  flex: 1;
  background-color: $light-85;
  padding: 0.75rem 0.75rem;
  height: 100%;
  display: flex;
  flex-direction: column;

  &.full-page {
    width: 100vw;
  }

  &.scroll-y {
    overflow-y: auto;
  }

  .similar-brochures {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    margin-bottom: 1.5rem;
  }
}
</style>
